import styled from 'styled-components';
import DefaultButton from 'components/Buttons/Button';
import DefaultActionButton from 'components/Buttons/ActionButton';
import DefaultInput, {
  PriceInput as DefaultPriceInput,
  FileInput as DefaultFileInput,
} from 'components/Form/Input';
import DefaultSelect from 'components/Form/FormSelect';
import { NotRoutedTab } from 'components/Tab';

const actionBarHeight = '6rem';

export const Tabs = styled.div`
  width: 70rem;
  margin: 0 auto 1.5rem;
  display: flex;
`;

export const Tab = styled(NotRoutedTab)``;

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  padding: 2rem;
  width: 70rem;
  background: ${({ theme }) => theme.colors.white};
  border-radius: 1.5rem;
  margin: auto auto 7rem auto;
`;

// TODO: TFR-49 split components into two or more different logical components
export const ActionBar = styled.div`
  position: fixed;
  bottom: 0;
  background: ${({ theme }) => theme.colors.white};
  box-shadow:
    0rem 0.5rem 1rem rgba(0, 0, 0, 0.1),
    0rem 0.5rem 2rem rgba(0, 0, 0, 0.1);
  height: ${actionBarHeight};
  width: 100%;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Actions = styled.div`
  width: 100%;
  max-width: 70rem;
  display: flex;
  justify-content: center;
  align-items: center;
`;

// TODO: TFR-45 make unique name or do not export
export const ActionButton = styled(DefaultActionButton)``;

// TODO: TFR-45:Button make unique name or do not export
export const Button = styled(DefaultButton)`
  margin-left: 1rem;
`;

// TODO: TFR-44 move to container group
export const FieldsContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 3fr;
  gap: 1.5rem;
  margin-bottom: 2rem;
`;

export const LeftColumn = styled.div``;

export const RightColumn = styled.div``;

// TODO: TFR-44 move to container group
export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 2rem;
`;

// TODO: TFR-45:Input make unique name or do not export
export const Input = styled(DefaultInput)`
  input {
    font-weight: 500;
    font-size: 1.1875rem;
  }
`;

// TODO: TFR-44 move to form group
export const PriceInput = styled(DefaultPriceInput)`
  input {
    font-weight: 500;
    font-size: 1.1875rem;
  }
`;

// TODO: TFR-44 move to form group
export const TextArea = styled(DefaultInput)`
  textarea {
    font-weight: 500;
    font-size: 1.1875rem;
  }
`;

// TODO: TFR-44 move to form group
export const ImageInput = styled(DefaultFileInput)``;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Select = styled(DefaultSelect)``;
